import { BrowserRouter, Routes, Route } from "react-router-dom";

import LayoutComBackground from "./Layouts/ComBackground";
import LayoutSemBackground from "./Layouts/SemBackground";

import Home from "./Pages/Home";
import Bairro from "./Pages/Bairro";
import PontosTuristicos from "./Pages/PontosTuristicos";
import FaleConosco from "./Pages/FaleConosco";
import NotFound from "./Pages/NotFound";
import JardimDeAlah from "./Pages/JardimDeAlah";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route element={<LayoutComBackground />}>
          <Route path="/" element={<Home />} />
          <Route path="/o-bairro" element={<Bairro />} />
          <Route path="/pontos-turisticos" element={<PontosTuristicos />} />
          <Route path="/contato" element={<FaleConosco />} />
        </Route>

        <Route element={<LayoutSemBackground />}>
          <Route path="/jardim-de-alah" element={<JardimDeAlah />} />
        </Route>

        <Route path="*" element={<NotFound />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
